import firstSliderImage from "../assets/firstImage.jpg";
import secondSliderImage from "../assets/711Y9Al9RNL._SX3000_.jpg";
import thirdSliderImage from "../assets/71qid7QFWJL._SX3000_.jpg";
import forthSliderImage from "../assets/61BvxKSpy3L._SX3000_.jpg";

export const SliderData = [
  {
    image: firstSliderImage,
  },
  {
    image: secondSliderImage,
  },
  {
    image: thirdSliderImage,
  },
  {
    image: forthSliderImage,
  },
];
